import React, { useContext } from 'react';
import { Box } from '@honda-canada/design-system-react';

import BottomLinks from '../shared/BottomLinks';
import FooterContext from '../service/FooterContext';
import themeStyles from '../Footer.styles';

const BottomContainer = themeStyles.apply(Box, 'BottomContainer');

const MenuBottom = () => {
  const { legalSection, mobileBottomLinksAlignment, styles } = useContext(FooterContext);

  return (
    <BottomContainer styles={styles.bottomContainer}>
      <BottomLinks title="legalSection" data={legalSection} alignment={mobileBottomLinksAlignment} />
    </BottomContainer>
  );
};

export default MenuBottom;
